// extracted by mini-css-extract-plugin
export default {"privacy":"Restaurant_privacy__9IP+p","listLink":"Restaurant_listLink__KB3pL"};